import { useEffect, FC } from "react";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { RootState } from "../../../app.store";
import { ToastType } from "states/global-value/global-value.models";
interface ToastProps {}
export const ToastComponent: FC<ToastProps> = (props) => {
  const toastState = useSelector((state: RootState) => state.globalValue.toast);
  const _onToast = () => {
    switch (toastState?.type) {
      case ToastType.success:
        toast.success(toastState?.message);
        break;
      case ToastType.error:
        toast.error(toastState?.message);
        break;
      case ToastType.warn:
        toast.warn(toastState?.message);
        break;
      case ToastType.info:
        toast.info(toastState?.message);
        break;
      case ToastType.dark:
        toast.dark(toastState?.message);
        break;
      default:  
        toast.success(toastState?.message);
        break;
    }
  };
  useEffect(() => {
    _onToast();
  }, [toastState]);
  return <ToastContainer  autoClose={2000} />;
};
